import {
  getLocalStorageDeviceId,
  getLocalStorageGuestUid,
  setLocalStorageDeviceId,
  setLocalStorageGuestUid,
} from '@services/storage';
import { StreamType, UserInfoItem, UserItem } from '@tencent/wemeet-websdk-next';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
// @ts-ignore
import md5 from 'md5';
import { isUserVideoOn } from './media';
import { randomNum } from '@utils/number';

/** @description 找到第一个视频打开的用户或者屏幕共享的用户 */
export const findFirstVideoOpenOrScreenOpenUser = (userList: UserInfoItem[]) => {
  let target;
  for (const user of userList) {
    if (
      user?.rtcStream?.streamType === StreamType.localAuxiliary ||
      user?.rtcStream?.streamType === StreamType.auxiliary
    ) {
      target = user;
      break;
    }

    // 开视频且有流的用户，最后一个 &&!target 是为了(On)复杂度得到结果
    if (isUserVideoOn(user) && !target) {
      target = user;
    }
  }

  return target;
};

export const isWxAppUser = (userId: UserItem) => userId?.['@instance_id'] === '8';

export const getGusetUid = async () => {
  const storeUid = getLocalStorageGuestUid();
  const storeDeviceId = getLocalStorageDeviceId();

  if (storeUid && storeDeviceId) {
    return {
      visitorAppUid: storeUid,
      deviceId: storeDeviceId,
    };
  }

  const fp = await FingerprintJS.load();
  const result = await fp.get();

  // This is the visitor identifier:
  const { visitorId } = result;

  const id = visitorId + randomNum(10);
  const visitorAppUid = `vst_${md5(id)}`;
  setLocalStorageGuestUid(visitorAppUid);
  setLocalStorageDeviceId(visitorId);

  return {
    visitorAppUid,
    deviceId: visitorId,
  };
};

/**
 * @description 生成app_token 用于xmpp auth信令
 * @param guestUid
 * @returns guestUid base64之后的值，和客户端统一，再组装信令的时候sdk会再此 base64 一下
 */
export const generateGuestToken = (guestUid: string) => window.btoa(guestUid);

/**
 * 将文字转为图片
 * @param {*} param0 -
 */
export const convertTextToImg = ({
  txt = '',
  fsize = 45, // 图片中字体的大小
  canvasWidth = 120,
  canvasHeight = 120,
  // 设置字体的位置
  fillTextX = 60,
  fillTextY = 60,
}) => {
  const fontWeight = 'bold';

  const canvas = document.createElement('canvas');

  canvas.width = canvasWidth;
  canvas.height = canvasHeight;

  const context = canvas.getContext('2d')!;
  // 设置文字背景颜色
  context.fillStyle = '#006FFF';
  context.fillRect(0, 0, canvas.width, canvas.height);
  // 设置文字颜色
  context.fillStyle = '#FFF';
  context.font = `${fontWeight} ${fsize}px sans-serif`;
  context.textAlign = 'center';
  context.textBaseline = 'middle';

  /**
   * context.fillText(text, x, y, maxWidth);
   * @param txt - 规定在画布上输出的文本。
   * @param x - 开始绘制文本的 x 坐标位置（相对于画布）。
   * @param y - 开始绘制文本的 y 坐标位置（相对于画布）。
   */
  context.fillText(txt, fillTextX, fillTextY);

  // canvas.style.display = 'none';
  // document.body.appendChild(canvas);

  return canvas.toDataURL('image/png');
};

/**
 * @description 获取头像
 */
export const generateAvatar = ({ username, avatar }: { username: string; avatar: string }) => {
  const defaultUrl = 'madialab-storage-1256380422.cos.ap-guangzhou.myqcloud.com/img/vst_ico80x80_2x.png';
  if (!username) {
    return avatar || `https://${defaultUrl}`;
  }

  const isDefaultAvatarUrl = avatar && avatar.indexOf(defaultUrl) !== -1;

  if (!avatar || isDefaultAvatarUrl) {
    let str = username;
    str = str.trim();

    /**
     * 英文字：RICKKKSUN  头像展示为R（取首字母）
     */
    // eslint-disable-next-line
    if (/^[a-zA-Z]+$/.test(str)) {
      // 纯英文
      str = str.substring(0, 1).toUpperCase();
    } else {
      // 取后两位
      const len = str.length - 2;
      str = str.substring(len);
    }

    const res = convertTextToImg({
      txt: str,
      canvasWidth: 120,
      canvasHeight: 120,
      fsize: 45,
      fillTextX: 60,
      fillTextY: 60,
    });
    return res;
  }

  return avatar;
};
